import { useEffect, useState } from "react";

import { Typography, Card, CardContent, Grid, Button, useTheme, Box, Badge, } from "@mui/material";
import FormatOverlineOutlinedIcon from '@mui/icons-material/FormatOverlineOutlined';
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import { useTranslation } from "react-i18next";
import usePurchaseReceivedList from "../../hooks/usePurchaseReceivedList";
import usePurchaseInspectionList from "../../hooks/usePurchaseInspectionList";
import usePurchaseOrderList from "../../hooks/usePurchaseOrderList";
import useRequestIndentList from "../../hooks/useRequestIndentList";
import SendIcon from '@mui/icons-material/Send';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';
import ChecklistIcon from '@mui/icons-material/Checklist';
import GroupsIcon from '@mui/icons-material/Groups';
import DescriptionIcon from '@mui/icons-material/Description';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import VerifiedIcon from '@mui/icons-material/Verified';
import ApprovalIcon from '@mui/icons-material/Approval';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PaymentIcon from '@mui/icons-material/Payment';

import { tokens } from "../../theme/theme";
import useUserPermissions from "../../components/user-permission/UserPermission";
import { hasPermission } from "../../components/user-permission/AuthorizationParameter";


import usePurchaseIndentList from "../../hooks/usePurchaseIndentList";
import useVendorEnquieyList from "../../hooks/useVendorEnquieyList";
import useVendorQuotationList from "../../hooks/useVendorQuotationList";
import DashboardCard from "../../components/common/DashboardCard";
import useVendorQuoteComparisonList from "../../hooks/useVendorQuoteComparisonList";
import useVendorEnquiryComparisonList from "../../hooks/purchase/useVendorEnquiryComparisionList";



const PurchaseManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const userPermissions = useUserPermissions();
    const callback = () => {
        handleBackDashboard();
    };
    const { receivedData, setReceivedData, refreshReceivedListSummary, } = usePurchaseReceivedList('inspection');
    const { orderData, setOrderData, refreshOrderListSummary, } = usePurchaseOrderList();
    const inspectionByCreated = usePurchaseInspectionList('Created');
    const notifyCreatedIndent = useRequestIndentList('notify request indent');
    const inspectionByApproved = usePurchaseInspectionList('Approved and Non-Returned');

    const [inspectionNotify, setInspectionNotify] = useState(0);
    const [inspectionNotifyApproved, setInspectionNotifyApproved] = useState(0);
    const [notification, setNotification] = useState(0);
    const [ponotification, setPONotification] = useState(0);
    const [requestIndentNotification, setRequestIndentNotification] = useState(0);
    const [PurchaseIndentNotification, setPurchaseIndentNotification] = useState(0);
    const [VendorEnquiryNotification, setVendorEnquiryNotification] = useState(0);
    const [VendorQuotationNotification, setVendorQuotationNotification] = useState(0);
    const [poPreviewnotification, setPOPreviewNotification] = useState(0);

    const { purchasedIndentList, loadPurchasedIndentByID, } = usePurchaseIndentList('purchase indent');
    const { vendorEnquiryList, setPurchasedIIndentList, selectPurchasedIndent, selectPurchasedIndentID, loadVendorEnquiryByID, } = useVendorEnquieyList('vendor enquiry');
    const { vendorQuotationList, loadVendorQuotationByID, } = useVendorQuotationList('Supplier quotation');
    const {
        comparisonList,
        selectedComparison,
        selectedComparisonID,
        setSelectedComparison,
        loadComparisonByID
    } = useVendorEnquiryComparisonList();

    

    //useVendorEnquiryComparisonList
    useEffect(() => {
        if (receivedData?.length > 0) {
            setNotification(receivedData.length);
        }
        else{
            setNotification(0)
        }
    }, [receivedData, setReceivedData]);

    useEffect(() => {
        if (Array.isArray(inspectionByCreated.inspectionList) && inspectionByCreated.inspectionList.length > 0) {
            setInspectionNotify(inspectionByCreated.inspectionList.length);
        }
        else{
            setInspectionNotify(0);
        }
    }, [inspectionByCreated.inspectionList]);

    useEffect(() => {
        if (Array.isArray(inspectionByApproved.inspectionList) && inspectionByApproved.inspectionList.length > 0) {
            setInspectionNotifyApproved(inspectionByApproved.inspectionList.length);
        }
        else{
            setInspectionNotifyApproved(0);
        }
    }, [inspectionByApproved.inspectionList]);


    useEffect(() => {
        if (orderData?.length > 0) {
            const approvedCount = orderData.filter(
                (item) => item.approval_status === "APPROVED"
            ).length;

            setPONotification(approvedCount);
        } else {
            setPONotification(0);
        }
    }, [orderData]);


    useEffect(() => {
        const list = notifyCreatedIndent.requestIndentList;
        if (Array.isArray(list) && list.length) {
            setRequestIndentNotification(list.length);
        }
        else{
            setRequestIndentNotification(0);
        }
    }, [notifyCreatedIndent.requestIndentList]);

    useEffect(() => {
        const createdCount = purchasedIndentList.filter(
            item => item?.status === "Created"
        ).length;

        setPurchaseIndentNotification(createdCount);
    }, [purchasedIndentList]);

    useEffect(() => {
        const createdCount = vendorEnquiryList.filter(
            item => item?.status === "Pending" || item?.status === "In Progress"
        ).length;

        setVendorEnquiryNotification(createdCount);
    }, [vendorEnquiryList]);


    useEffect(() => {
        const createdCount = vendorQuotationList.filter(
            item => item?.status === "pending"
        ).length;

        setVendorQuotationNotification(createdCount);
    }, [vendorQuotationList]);




    useEffect(() => {
        if (comparisonList?.length > 0) {
            let approvedComparisons = comparisonList.filter(item => item.status === 'Approved');
            setPOPreviewNotification(approvedComparisons.length);
        } else {
            setPOPreviewNotification(0);
        }
    }, [comparisonList, setPOPreviewNotification]);

    return (
        <Box >
            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">{t('purchase-menu.purchasemanagement')} </Typography>
                    </Box>

                </CardContent>
            </Card>

            {/* scan bar code */}

            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >
                    {hasPermission(userPermissions, "Vendor", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <LooksOutlinedIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>{t('purchase-menu.vendor')}</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewVendorPage")}>Add</Button>
                        //     </Card>
                        // </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.vendor')}
                                icon={<LooksOutlinedIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewVendorPage")}
                                subtitle="Add"
                            />
                        </Grid>
                    )}

                    {hasPermission(userPermissions, "Request Indent", "Enabled") && (                       

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.indentgeneration')}
                                icon={<SendIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("RequestIndent")}
                                subtitle="Add"
                            />
                        </Grid>

                    )}

                    {hasPermission(userPermissions, "Approve Request Indent", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>

                        //         <Badge
                        //             badgeContent={requestIndentNotification}
                        //             color="error"
                        //             overlap="circular"
                        //             sx={{
                        //                 "& .MuiBadge-badge": {
                        //                     fontSize: "10px",
                        //                     height: "16px",
                        //                     minWidth: "16px",
                        //                     padding: "0 4px",
                        //                 },
                        //             }}
                        //         >
                        //             <SwipeRightIcon fontSize="large" />
                        //         </Badge>
                        //         <Typography variant="h6" mt={2}>Approve Indent</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ApproveRequestIndent")}>Add</Button>
                        //     </Card>
                        // </Grid>

                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >
                        //             <Badge
                        //                 badgeContent={requestIndentNotification}
                        //                 color="error"
                        //                 overlap="circular"
                        //                 sx={{
                        //                     "& .MuiBadge-badge": {
                        //                         fontSize: "10px",
                        //                         height: "16px",
                        //                         minWidth: "16px",
                        //                         padding: "0 4px",
                        //                     },
                        //                 }}
                        //             >
                        //                 <SwipeRightIcon fontSize="large" color="secondary" />
                        //             </Badge>
                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             Approve Indent
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("ApproveRequestIndent")}
                        //         >
                        //             Add
                        //         </Button>
                        //     </Card>
                        // </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.indentapproval')}
                                icon={<SwipeRightIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ApproveRequestIndent")}
                                badge={requestIndentNotification}
                                subtitle="Add"
                            />
                        </Grid>
                    )}

                    {hasPermission(userPermissions, "Purchase Indent", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <ChecklistIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>Purchase Indent</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("PurchaseIndent")}>Add</Button>
                        //     </Card>
                        // </Grid>
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >

                        //             <ChecklistIcon fontSize="large" color="secondary" />

                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             Purchase Indent
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("PurchaseIndent")}
                        //         >
                        //             Add
                        //         </Button>
                        //     </Card>
                        // </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.purchase_indent')}
                                icon={<ChecklistIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("PurchaseIndent")}
                                // badge={requestIndentNotification}
                                subtitle="Add"
                            />
                        </Grid>
                    )}

                    {hasPermission(userPermissions, "Vendor Enquiry", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <GroupsIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>Vendor Enquiry</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("VendorEnquiry")}>View</Button>
                        //     </Card>
                        // </Grid>
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >

                        //             <GroupsIcon fontSize="large" color="secondary" />

                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             Vendor Enquiry
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("VendorEnquiry")}
                        //         >
                        //             View
                        //         </Button>
                        //     </Card>
                        // </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.purchase_quotation')}
                                icon={<GroupsIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("VendorEnquiry")}
                                badge={PurchaseIndentNotification}
                                subtitle="View"
                            />
                        </Grid>

                    )}


                    {hasPermission(userPermissions, "Vendor Quotation", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <DescriptionIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>Vendor Quotation</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("VendorQuotation")}>View</Button>
                        //     </Card>
                        // </Grid>

                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >

                        //             <DescriptionIcon fontSize="large" color="secondary" />

                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             Vendor Quotation
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("VendorQuotation")}
                        //         >
                        //             View
                        //         </Button>
                        //     </Card>
                        // </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.supplierquotation')}
                                icon={<DescriptionIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("VendorQuotation")}
                                badge={VendorEnquiryNotification}
                                subtitle="View"
                            />
                        </Grid>
                    )}

                    {hasPermission(userPermissions, "Vendor Quotation", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <CompareArrowsIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>Quotation Analysis</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("VendorQuotationForComparison")}>View</Button>
                        //     </Card>
                        // </Grid>
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >

                        //             <CompareArrowsIcon fontSize="large" color="secondary" />

                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             Quotation Analysis
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("VendorQuotationForComparison")}
                        //         >
                        //             View
                        //         </Button>
                        //     </Card>
                        // </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.quotationcomparison')}
                                icon={<CompareArrowsIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("VendorQuotationForComparison")}
                                badge={VendorQuotationNotification}
                                subtitle="View"
                            />
                        </Grid>

                    )}

                    {/* {hasPermission(userPermissions, "Return Indent", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <KeyboardReturnIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>Return Indent</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ReturnIndent")}>Add</Button>
                        //     </Card>
                        // </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>                          

                             <DashboardCard
                                title= {t('purchase-menu.purchasereturnrequest')}
                                icon={<KeyboardReturnIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ReturnIndent")}
                                
                                subtitle="View"
                            />
                        </Grid>

                    )} */}

                    {hasPermission(userPermissions, "Purchase Order", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         <ShoppingCartIcon fontSize="large" />
                        //         <Typography variant="h6" mt={2}>{t('purchase-menu.purchase_order')}</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewPurchaseOrder")}>View</Button>
                        //     </Card>
                        // </Grid>

                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >
                        //             <Badge
                        //                 badgeContent={ponotification}
                        //                 color="error"
                        //                 overlap="circular"
                        //                 sx={{
                        //                     "& .MuiBadge-badge": {
                        //                         fontSize: "10px",
                        //                         height: "16px",
                        //                         minWidth: "16px",
                        //                         padding: "0 4px",
                        //                     },
                        //                 }}
                        //             >
                        //                 <ShoppingCartIcon fontSize="large" color="secondary" />
                        //             </Badge>
                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             {t('purchase-menu.purchase_order')}
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("ViewPurchaseOrder")}
                        //         >
                        //             View
                        //         </Button>
                        //     </Card>
                        // </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.purchase_order')}
                                icon={<ShoppingCartIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewPurchaseOrder")}
                                 badge={poPreviewnotification}
                                subtitle="View"
                            />
                        </Grid>

                    )}

                    {hasPermission(userPermissions, "Purchase Received", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                        //         {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                        //         <Badge
                        //             badgeContent={ponotification}
                        //             color="error"
                        //             overlap="circular"
                        //             sx={{
                        //                 "& .MuiBadge-badge": {
                        //                     fontSize: "10px",
                        //                     height: "16px",
                        //                     minWidth: "16px",
                        //                     padding: "0 4px",
                        //                 },
                        //             }}
                        //         >
                        //             <CallReceivedIcon fontSize="large" />
                        //         </Badge>
                        //         <Typography variant="h6" mt={2}>Purchase Received</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewPurchaseReceives")}>View</Button>
                        //     </Card>
                        // </Grid>                       

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.goods_received_note')}
                                icon={<CallReceivedIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewPurchaseReceives")}
                                badge={ponotification}
                                subtitle="View"
                            />
                        </Grid>

                    )}

                    {hasPermission(userPermissions, "Receives QC Inspection", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         sx={{
                        //             backgroundColor: colors.primary[400],
                        //             p: 2,
                        //             borderRadius: 2,
                        //             textAlign: "center",
                        //         }}
                        //     >
                        //         <Badge
                        //             badgeContent={notification}
                        //             color="error"
                        //             overlap="circular"
                        //             sx={{
                        //                 "& .MuiBadge-badge": {
                        //                     fontSize: "10px",
                        //                     height: "16px",
                        //                     minWidth: "16px",
                        //                     padding: "0 4px",
                        //                 },
                        //             }}
                        //         >
                        //             <VerifiedIcon fontSize="large" />
                        //         </Badge>

                        //         <Typography variant="h6" mt={2}>
                        //             Receives QC Inspection
                        //         </Typography>

                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("ViewQCcheck")}
                        //         >
                        //             View
                        //         </Button>
                        //     </Card>
                        // </Grid>



                         <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.qcinspection')}
                                icon={<VerifiedIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewQCcheck")}
                                badge={notification}
                                subtitle="View"
                            />
                        </Grid>

                    )}

                    {hasPermission(userPermissions, "Receives Approval", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>

                        //         <Badge
                        //             badgeContent={inspectionNotify}
                        //             color="error"
                        //             overlap="circular"
                        //             sx={{
                        //                 "& .MuiBadge-badge": {
                        //                     fontSize: "10px",
                        //                     height: "16px",
                        //                     minWidth: "16px",
                        //                     padding: "0 4px",
                        //                 },
                        //             }}
                        //         >
                        //             <ApprovalIcon fontSize="large" />
                        //         </Badge>
                        //         <Typography variant="h6" mt={2}>Receives Approval</Typography>
                        //         <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewReceivesApproval")}>View</Button>
                        //     </Card>
                        // </Grid>



                      <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.grnapproval')}
                                icon={<ApprovalIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewReceivesApproval")}
                                badge={inspectionNotify}
                                subtitle="View"
                            />
                        </Grid>


                    )}

                    {hasPermission(userPermissions, "Purchase Inspection Return", "Enabled") && (
                        // <Grid item xs={12} sm={6} md={4} lg={3}>
                        //     <Card
                        //         elevation={3}
                        //         sx={{
                        //             backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        //             "&:hover": {
                        //                 transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                        //             },
                        //         }}
                        //     >
                        //         <Box
                        //             sx={{
                        //                 width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                        //             }}
                        //         >
                        //             <Badge
                        //                 badgeContent={inspectionNotifyApproved}
                        //                 color="error"
                        //                 overlap="circular"
                        //                 sx={{
                        //                     "& .MuiBadge-badge": {
                        //                         fontSize: "10px",
                        //                         height: "16px",
                        //                         minWidth: "16px",
                        //                         padding: "0 4px",
                        //                     },
                        //                 }}
                        //             >
                        //                 <KeyboardBackspaceIcon fontSize="large" color="secondary" />
                        //             </Badge>
                        //         </Box>
                        //         <Typography variant="h6" fontWeight={600}>
                        //             Purchase Inspection Return
                        //         </Typography>
                        //         <Button
                        //             variant="contained"
                        //             color="secondary"
                        //             sx={{ mt: 2 }}
                        //             onClick={() => SetActive("ViewPurchaseInspectionReturns")}
                        //         >
                        //             View
                        //         </Button>
                        //     </Card>
                        // </Grid>

                         <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('purchase-menu.purchase_returns')}
                                icon={<KeyboardBackspaceIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewPurchaseInspectionReturns")}
                                badge={inspectionNotifyApproved}
                                subtitle="View"
                            />
                        </Grid>


                    )}

                    {/* <Grid item xs={12} sm={6} md={4} lg={2}>
                        <DashboardCard
                            title={t('purchase-menu.purchase_bill')}
                            icon={<PaymentIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("ViewPurchaseBills")}
                            // badge={inspectionNotifyApproved}
                            subtitle="View"
                        />
                    </Grid> */}

                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            elevation={3}
                            sx={{
                                backgroundColor: colors.primary[400], borderRadius: 3, p: 3, textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                "&:hover": {
                                    transform: "translateY(-5px)", boxShadow: theme.shadows[6],
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60, height: 60, mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.primary[400], borderRadius: "50%", mb: 2,
                                }}
                            >

                                <PaymentIcon fontSize="large" color="secondary" />

                            </Box>
                            <Typography variant="h6" fontWeight={600}>
                                {t('purchase-menu.purchase_bill')}
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 2 }}
                                onClick={() => SetActive("ViewPurchaseBills")}
                            >
                                View
                            </Button>
                        </Card>
                    </Grid> */}


                </Grid>
            </Box>
        </Box>

    )
}
export default PurchaseManagementMenu;